import { noop } from '@showroomjs/core';
import { createNameContext, useStableCallback } from '@showroomjs/ui';
import * as React from 'react';
const A11yResultContext = createNameContext('A11yResultContext', {
    result: undefined,
    setResult: noop,
    status: 'idle',
    setStatus: noop,
});
export const useA11yResult = () => React.useContext(A11yResultContext);
const isEqualLength = (arr1, arr2) => arr1.length === arr2.length;
const keys = ['violations', 'passes', 'incomplete'];
const isDifferentResult = (result1, result2) => {
    if (keys.some((key) => !isEqualLength(result1[key], result2[key]))) {
        return true;
    }
    if (keys.some((key) => result1[key].some((v, i) => !isEqualLength(v.nodes, result2[key][i].nodes)))) {
        return true;
    }
    return false;
};
export const A11yResultContextProvider = (props) => {
    const [result, setResult] = React.useState(props.result);
    const [status, setStatus] = React.useState('idle');
    const onChange = useStableCallback(props.onResultChange);
    const usedResult = props.result || result;
    return (React.createElement(A11yResultContext.Provider, { value: React.useMemo(() => ({
            result: usedResult,
            setResult: function (newResult) {
                if (newResult &&
                    (!result || isDifferentResult(result, newResult))) {
                    setResult(newResult);
                    onChange(newResult);
                    setStatus('success');
                }
            },
            status,
            setStatus,
        }), [usedResult, status]) }, props.children));
};
const A11yResultByFrameContext = createNameContext('A11yResultByFrameContext', {
    resultByFrameName: {},
    setResult: noop,
});
export const A11yResultByFrameContextProvider = (props) => {
    const [resultByFrameName, setResultByFrameName] = React.useState({});
    return (React.createElement(A11yResultByFrameContext.Provider, { value: React.useMemo(() => ({
            resultByFrameName,
            setResult(frameName, result) {
                setResultByFrameName((prev) => (Object.assign(Object.assign({}, prev), { [frameName]: result })));
            },
        }), [resultByFrameName]) }, props.children));
};
export const useA11yResultByFrame = () => React.useContext(A11yResultByFrameContext);
//# sourceMappingURL=use-a11y-result.js.map